<template>
    <div>
        <nav class="top-bar" :style="{ marginLeft: sidebarWidth, width: `calc(100% - ${sidebarWidth})` }">
            <div class="logo-container">
                <img src="@/assets/apple.png" alt="Apfel Logo" class="logo" />
                <router-link to="/" class="site-name">
                    Apfel Hosting
                </router-link>
            </div>
            <div class="top-bar-content">
                <div class="creditsdiv">
                    <img src="@/assets/servers.png" alt="servers">
                    <p class="serverslots">{{ server_count }}/{{ server_slots }}</p>
                    <img src="@/assets/wallet.png" alt="wallet">
                    <p class="credits">{{ credits }}</p>
                </div>
                <p class="username">{{ name }}</p>
            </div>
            </nav>

        <div :class="['sidebar', { open: isOpen }]" @mouseenter="setSidebar(true)" @mouseleave="setSidebar(false)">
            <button class="toggle-button" @click="toggleSidebar">
                <img src="@/assets/threelines.png" alt="Three Lines" class="toggle-icon" />
            </button>
            

            <nav class="navigation">
                <ul>
                    <li v-for="link in links" :key="link.name">
                    <button @click="changeRoute(link.url)" :class="{ active: route.path === link.url }">
                        <img :src="link.image" :alt="link.name">
                        <span v-if="isOpen">{{ link.name }}</span>
                    </button>
                    </li>

                    <div class="admin-div" v-if="role === 'admin'">
                        <h4 v-if="isOpen" class="admin-title">Admin</h4>
                        <h4 v-if="!isOpen" class="admin-title">---</h4>
                    </div>
                    <li v-for="link in adminLinks" :key="link.name">
                    <button @click="changeRoute(link.url)" :class="{ active: route.path === link.url }" v-if="role === 'admin'">
                        <img :src="link.image" :alt="link.name">
                        <span v-if="isOpen">{{ link.name }}</span>
                    </button>
                    </li>
                </ul>
            </nav>

        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import router from '@/router';

import homeIcon from '@/assets/home.png';
import serversIcon from '@/assets/servers.png';
import usersIcon from '@/assets/users.png';



const store = useStore();
const name = computed(() => store.state.name);
const credits = computed(() => store.state.credits);
const server_count = computed(() => store.state.server_count);
const server_slots = computed(() => store.state.server_slots);
const role = computed(() => store.state.role);
const isOpen = computed(() => store.state.isSidebarOpen);
const sidebarWidth = computed(() => store.getters.sidebarWidth);
const route = useRoute();

const links = [
  { name: 'Home', url: '/dashboard', image: homeIcon },
  { name: 'Servers', url: '/servers', image: serversIcon },
];

const adminLinks = [
  { name: 'Servers', url: '/admin/servers', image: serversIcon },
  { name: 'Users', url: '/admin/users', image: usersIcon },
];


const toggleSidebar = () => {
  store.dispatch('toggleSidebar');
};

const setSidebar = (to) => {
  store.dispatch('setSidebar', to);
};

const changeRoute = (route) => {
  router.push(route);
};
</script>

<style>

.top-bar {
    position: fixed;
    top: 0;
    left: 0;
    height: 70px;
    background-color: #081F5C;
    color: white;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    transition: margin-left 0.3s ease, width 0.3s ease;
    width: calc(100% - var(--sidebar-width));
    overflow: hidden;
}

.logo-container {
    display: flex;
    align-items: center;
    margin-left: 12px;
}

.logo {
    height: 45px;
    margin-right: 0.7rem;
}

.site-name {
    font-size: 2rem;
    font-weight: bold;
    color: white;
    text-decoration: none;
    text-shadow: 2px 2px 0 black;
    margin-right: 1.2rem;
}

.top-bar-content {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.username {
    font-size: 1.3rem;
    color: white;
    text-shadow: 1px 1px 0 black;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 15px;
}

.credits, .serverslots {
    font-size: 1.3rem;
    color: white;
    text-shadow: 1px 1px 0 black;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-left: 15px;
    padding-right: 80px;
}

.creditsdiv {
    display: flex;
    align-items: center;
    padding-right: 70px;
}

.creditsdiv img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border-radius: 4px;
}

.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: var(--sidebar-width);
    height: 100vh;
    background-color: #081F5C;
    transition: width 0.3s ease;
    z-index: 999;
}

.sidebar:not(.open) {
    --sidebar-width: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sidebar.open {
    --sidebar-width: 160px;
}

.toggle-button {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
    z-index: 2000;
    transition: background-color 0.3s ease;
}

.toggle-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.toggle-icon {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.navigation {
    padding: 60px 0 10px;
}

.navigation ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.navigation li {
    margin: 10px 0;
    text-align: left;
    padding: 0 10px;
}

.navigation button {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 18px;
    font-weight: bold;
    padding: 10px 15px;
    display: block;
    border-radius: 7px;
    overflow: hidden;
    white-space: nowrap;
    background-color: transparent;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease, padding 0.3s ease, text-align 0.3s ease;
    width: 100%;
}

.navigation button.active {
    background-color: #d8972f;
    color: white;
    font-weight: bold;
    padding-left: 20px;
    padding-right: 15px;
}

.sidebar:not(.open) .navigation button.active {
    background-color: #d8972f;
    color: white;
    font-weight: bold;
    padding-left: 5px;
    padding-right: 5px;
}

.sidebar:not(.open) .navigation button {
    text-align: center;
    padding: 10px 0;
}

.sidebar:not(.open) .navigation button span:nth-child(2) {
    display: none;
}

.navigation img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border-radius: 4px;
    transition: transform 0.2s ease-in-out;
}

.sidebar.open .navigation button {
    display: flex;
    align-items: center;
    padding-left: 10px;
}

.sidebar.open .navigation span {
    padding-left: 10px;
}

.sidebar:not(.open) .navigation button {
    display: flex;
    justify-content: center;
}

.sidebar:not(.open) .navigation img {
    margin-right: 0;
}
.sidebar.open .navigation img {
    margin-right: 0;
}

.admin-section {
    margin-top: 30px;
}

.admin-title {
    font-size: 1.2rem;
    font-weight: bold;
    color: white;
    padding: 10px;
}
.admin-div {
    display: flex;
    justify-content: center;
}
.sidebar.open .admin-div {
    padding-left: 10px;
    justify-content: left;
}

</style>
